import React from 'react';
import { Box, Radio, RadioGroup } from '@chakra-ui/react';

function FilterRadioGroup({ value, ascValue = 'asc', descValue = 'desc', onChange }) {
  return (
    <RadioGroup
      alignItems="flex-start"
      display="flex"
      flexDirection="column"
      value={value}
      onChange={val => onChange(val)}
    >
      <Radio my={1} value={ascValue}>
        <Box as="span" color="greyScale.900" textStyle="bodyMd">
          {'Ascending Order: '}
        </Box>
        <Box as="span" color="primaryScale.600" textStyle="bodyMd500">
          A &#8594; Z / 0 &#8594; 9
        </Box>
      </Radio>
      <Radio my={1} value={descValue}>
        <Box as="span" color="greyScale.900" textStyle="bodyMd">
          {'Descending Order: '}
        </Box>
        <Box as="span" color="primaryScale.600" textStyle="bodyMd500">
          Z &#8594; A / 9 &#8594; 0
        </Box>
      </Radio>
    </RadioGroup>
  );
}

export default FilterRadioGroup;
